export default {
  setProperty(state, { propertyName, value = null }) {
    state[propertyName] = value;
  },
  GetActionMessage(state, newValue) {
    state.actionMessage = newValue;
  },
  //Student Methods:
  setOldSelectedStudent(state, oldSelectedStudent) {
    state.selectedStudent = oldSelectedStudent;
    state.studentId = oldSelectedStudent.studentId;
    state.oldstudentId = oldSelectedStudent.studentId;
  },
  //Pei Methods:
  // TODO: Change because don't save in store information to pass another view
  setProvisionalRemedyRequestRef(state, newProvisionalRemedyRequestRef) {
    state.ProvisionalRemedyRequestRef = newProvisionalRemedyRequestRef;
  },
  setProvisionalRemedyRequest(state, newProvisionalRemedyRequest) {
    state.ProvisionalRemedyRequest = newProvisionalRemedyRequest;
  },
  // END TODO
  setFiltersFromProvisionalRemedyRequestRef(
    state,
    newFiltersFromProvisionalRemedyRequestRef
  ) {
    state.FiltersFromProvisionalRemedyRequest = newFiltersFromProvisionalRemedyRequestRef;
  },
  setSelectedPei(state, newSelectedPei) {
    state.peiSelected = newSelectedPei;
  },
  setSelectedPeiRevisionNo(state, revisionNumber) {
    state.peiSelectedGeneralRevisionNo = revisionNumber;
  },
  setSelectedPlacementCommitte(state, newPlacementCommitte) {
    state.placementCommittee = newPlacementCommitte;
  },
  setSelectedTransitionServicesFlag(state, newTransitionServicesFlag) {
    state.pei.transitionServicesFlag = newTransitionServicesFlag;
  },
  setSelectedPeiStatus(state, newSelectedPeiStatus) {
    state.pei.peiStatusCode = newSelectedPeiStatus;
  },
  setSelectedPeiStatusDescription(state, newSelectedPeiStatusDescription) {
    state.pei.peiStatusCodeDescription = newSelectedPeiStatusDescription;
  },
  setSelectedSignatureParticipant(state, singatureParticipant) {
    state.singatureParticipant = singatureParticipant;
  },
  setSelectedPeiEvaluationDateId(state, peiEvaluationDateId) {
    state.pei.peiEvaluationDateId = peiEvaluationDateId;
  },
  setSelectedPeiConfigUnilateralFlag(state, newConfigUnilateralFlag) {
    state.pei.configUnilateralFlag = newConfigUnilateralFlag;
  },
  setSelectedPeiConfigExtendedSchoolYearFlag(state, extendedSchoolYearFlag) {
    state.pei.extendedSchoolYearFlag = extendedSchoolYearFlag;
  },
  setSelectedPeiConfigOtherServTechAssistEquipFlag(
    state,
    otherServTechAssistEquipFlag
  ) {
    state.pei.otherServTechAssistEquipFlag = otherServTechAssistEquipFlag;
  },
  setSelectedPeiLocationRejected(state, locationRejected) {
    state.pei.peiLocationRejected = locationRejected;
  },
  setSelectedPeiInfo(state, newPeiInfo) {
    state.pei = newPeiInfo;
  },
  setPeiHasAcademicAreas(state, hasAA) {
    state.peiHasAcademicAreas = hasAA;
  },
  setPeiHasAlternativeAcademicUbications(state, hasAAU) {
    state.peiHasAlternativeAcademicUbications = hasAAU;
  },
  setPreviousPeiId(state, previousPeiId) {
    state.pei.previousPeiId = previousPeiId;
  },
  //---- end Pei Methods
  setATSaveBtnDisable(state, isDisabled) {
    state.atSaveBtnDisabled = isDisabled;
  },
  setSelectedAt(state, newSelectedAt) {
    state.atSelected = newSelectedAt;
  },
  //Preliminary methods
  setSelectPreEvalAnswer(state, preEvaluationAnswer) {
    state.preEvaluationAnswer = preEvaluationAnswer;
  },
  setSelectRecentlyEvalBy(state, recentlyEvaluatedBy) {
    state.recentlyEvaluatedBy = recentlyEvaluatedBy;
  },
  setAtValidationTriggered(state, value) {
    state.atValidationTriggered = value;
  },
  SetStudentTherapies(state, value) {
    if (value != undefined) {
      if (value != null) {
        for (let ii = 0; ii < value.length; ii++) {
          value[ii].index = ii + 0;
          value[ii].Active = '';
          value[ii].selected = false;
          if (ii == 0) {
            value[ii].Active = 'active';
            value[ii].selected = true;
          }
        }
      }
    }
    state.studentTherapies = value;
  },
  // Tabs
  setSaveMethod(state, saveCallback) {
    state.tab.saveMethod = saveCallback;
  },
  setChangeInitEvaluationMethod(state, changeInitEvaluationCallback) {
    state.tab.changeInitEvaluationMethod = changeInitEvaluationCallback;
  },
  setSaveChange(state, saveCallback) {
    state.studentSave = saveCallback;
  },
  setResetOriginalDataMethod(state, resetOldDataCallback) {
    state.tab.resetOriginalDataMethod = resetOldDataCallback;
  },
  setOldStudent(state, resetOldDataCallback) {
    state.resetStudent = resetOldDataCallback;
  },
  setFormDirty(state, payload) {
    if (payload.resetMethod) state.tab.resetMethod = payload.resetMethod;
    if (!payload.value && state.tab.resetMethod) state.tab.resetMethod();

    state.tab.currentFormDirty = payload.value;
  },
  setSaveBtnVisibility(state, visibility) {
    state.tab.showSaveBtn = visibility;
  },
  setActiveATTab(state, saveFunc) {
    state.activeATTab = saveFunc;
  },
  setAtCompleted(state, value) {
    state.atCompleted = value;
  },
  // Affirmative Letters
  setSelectedPeiAffirmativeLetter(state, newSelectedPeiAffirmativeLetter) {
    state.peiAffirmativeLetterSelected = newSelectedPeiAffirmativeLetter;
  },
  SetServiceTypeId(state, typeId) {
    state.serviceTypeId = typeId;
  },
  setPeiValidationTriggered(state, value) {
    state.peiValidationTriggered = value;
  },
  // Set Pei Analisys Service
  setAnalysisServiceId(state, value) {
    state.analysisServiceId = value;
  },
  setPeiTransportationInfo(state, transportationInfo) {
    state.peiTransportationInfo = transportationInfo;
  },
  setSelectedAreaExtended(state, newAreaExtended) {
    state.areaExtendedSelected = newAreaExtended;
  },
  setSelectedEvidenceReportParams(state, evidenceReportParams) {
    state.rlvEvidenceReportParams = evidenceReportParams;
  },
  setSelectedPeiAcademicYearId(state, configAcademicYearId) {
    state.pei.academicYearId = configAcademicYearId;
  },
  setPeiControversies(state, controversies) {
    state.pei.controversies = controversies;
  },
  setPeiTab2Information(state, newValue) {
    state.peiTab2.peiId = state.peiSelected;
    state.peiTab2.evaluationAnalysisDate = newValue.evaluationAnalysisDate
      ? new Date(newValue.evaluationAnalysisDate)
      : null;
    state.peiTab2.evaluationTriannualDate = newValue.evaluationTriannualDate
      ? new Date(newValue.evaluationTriannualDate)
      : null;
    state.peiTab2.generalImpedimentDescription =
      newValue.generalImpedimentDescription;
    state.peiTab2.hasResultSummary = newValue?.hasResultSummary ?? false;
    state.peiTab2.resultSummaryAnalysisServiceIds =
      newValue?.resultSummaryAnalysisServiceIds ?? [];
  },
  setParentRouter(state, routerInfo) {
    state.parentsRouter.push(routerInfo);
  },
  setVisiblePeiSignSection(state, isVisible) {
    state.peiTab1.showSignSection = isVisible;
  },
  setFlagSignatureCompu(state, value) {
    state.peiTab10.isCompuFileParameterEnable = value;
  },
  setFlagSignaturePei(state, value) {
    state.peiTab10.isSignedPeiParameterEnable = value;
  },
  setFlagActiveEducationalCompensatoryService(state, value) {
    state.activeEducationalCompensatoryService = value;
  },
  //Set Navigation Menu
  setNavigationToViewRoute(state, route) {
    state.navigateToViewRoute = route;
  },
  setNavigationToViewCard(state, cardId) {
    state.navigateToViewCard = cardId;
  },
  //Set Student PreRegistry
  setExit(state, val) {
    state.exit = val;
  },
  setSignSectionVisibles(state, value) {
    state.peiTab1.signSectionVisibles = value;
  },
  setWebServiceStudentSearchEnabled(state, val) {
    state.webServiceStudentSearchEnabled = val;
  },
  setSelectedStudentMustHaveRegistration(state, val) {
    state.selectedStudentMustHaveRegistration = val;
  },
  setRegister(state, val) {
    state.register = val;
  },
  setRegisterEvaluation(state, val) {
    state.register.evaluations = val;
  },
  setRegisterMethod(state, registerCallBack) {
    state.tab.registerMethod = registerCallBack;
  },
  SetPreregisterFlag(state, data) {
    state.flagPreregister = data;
  },
  setComponentValidated(state, payload) {
    payload.map((component) => {
      if (component != undefined) {
        state.componentsValidated[component.name] = component.isValid;
      }
    });
  },
  setIsNavOpen(state, value) {
    state.isNavOpen = value;
  },
  toggleNav(state) {
    state.isNavOpen = !state.isNavOpen;
  },
  setIsMobileDensity(state, value) {
    state.isMobileDensity = value;
  },
  setIsAiAssistantDocked(state, value) {
    state.aiAssistantDocked = value;
  },
  // 15 sep -- guarda el último modo ('small' | 'docked' | 'fullscreen') elegido en
  // cualquier diálogo del Asistente de IA del PEI, para que la próxima instancia de
  // AiAssistantModal.vue (p.ej. el de Objetivos que se abre solo tras crear una Meta
  // con el Asistente IA) arranque en el mismo modo en vez de siempre en 'small'.
  setAiAssistantPreferredMode(state, value) {
    state.aiAssistantPreferredMode = value;
  },
  setShowEditionCallaout(state, value) {
    state.showEditionCallaout = value;
  },
  setAfterConfirmAppointmentMethod(state, afterConfirmAppointmentCallback) {
    state.afterConfirmAppoinmentMethod = afterConfirmAppointmentCallback;
  },
  setUserHasValidRole(state, value) {
    state.userHasValidRole = value;
  },
  setShowRefreshSignatureTab(state, value) {
    state.showRefreshSignatureTab = value;
  },
  setSignatureDocument(state, value) {
    state.signatureDocument = value;
  },
  setTab10SignatureInfo(state, value) {
    state.tab10SignatureInfo = {
      ...state.tab10SignatureInfo,
      ...value,
    };
  },
  setJustSaveTab10(state, value) {
    state.justSaveTab10 = value;
  },
  setShowSignatureCancellationDocument(state, value) {
    state.pei = {
      ...state.pei,
      showSignatureCancellationDocument: value,
    };
  },
  setIsDigitalSignatureCancelled(state, value) {
    state.pei = {
      ...state.pei,
      isDigitalSignatureCancelled: value,
    };
  },
  setTab10IsEnabled(state, value) {
    state.pei = {
      ...state.pei,
      tab10IsEnabled: value,
    };
  },
  setATServiceAmmendment(state, value) {
    state.peiATAmmendment = value;
  },
  setShowDigitalSignatureActions(state, value) {
    state.showDigitalSignatureActions = value;
  },
  setCompensatoryServices(state, newData) {
    state.compensatoryServicesValidation = newData;
  },
  setCompensatoryServicesQuestion(state, newData) {
    state.compensatoryQueston = newData;
  },

  setResultSummaryValidation(state, newData) {
    state.resultSummaryValidation = newData;
  },
  setRequireUsageGuaranteeCompletionEnabled(state, value) {
    state.requireUsageGuaranteeCompletionEnabled = value;
  },
  setTriannualEvaluation(state, value) {
    state.triannualEvaluation = value;
  },
  setRegistryTriannualEvaluation(state, value) {
    state.registryTriannualEvaluation = value;
  },
  setRegistryTriannualEvaluationList(state, value) {
    state.registryTriannualEvaluationList = value;
  },
};
